import { Container, Row, Col } from "react-bootstrap";
import ProtectedRoutes from "../../../auth/utils/ProtectedRoutes";
import { PageHeader } from "../../../../components/PageHeader";
import { useState } from "react";
import CompletedCounsellingBody from "./components/CompletedCounsellingBody";

const CompletedCounselling = () => {
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <Container fluid>
      <PageHeader
        title="Completed Counselling"
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />

      <Row>
        <Col>
          <CompletedCounsellingBody searchQuery={searchQuery} />
        </Col>
      </Row>
    </Container>
  );
};

export default ProtectedRoutes(CompletedCounselling, {
  allowedRoles: ["Super Admin", "Admin"],
});
